<app-responsive-tab navigate="tab" [default]="MetadataType.Skill" [tabs]="tabs" (active)="tab=$event">
</app-responsive-tab>

<div class="p-2">
  <div class="container d-flex align-items-center justify-content-between pb-1">
    <label>
      <span>جستجو</span>
      <input type="text" [(ngModel)]="search" />
    </label>
    <label>
      <input type="checkbox" [(ngModel)]="hasNoVariations" (change)="filtered=null" />
      <span>بدون مشابه یا جایگزین</span>
    </label>
    <label>
      <input type="checkbox" [(ngModel)]="showVerified" (change)="filtered=null" />
      <span>تایید شده ها</span>
    </label>
    <ng-container *ngIf="tab.name==MetadataType.WrongSkill">
      <button class="btn fs-sm" (confirm)="processAll()">اجرای تایید شده‌ها</button>
      <!-- <button class="btn fs-sm" (confirm)="removeProcessed()">حذف اجرا شده‌ها</button> -->
      <button class="btn fs-sm" (click)="open(-1)">ایجاد گروهی</button>
    </ng-container>
    <button class="btn fs-sm"
      (click)="removeDuplicates()">{{!duplicates?'یافتن ':(duplicates.length?'حذف '+(duplicates.length|number):'بدون')}}
      تکراری</button>
    <button class="btn fs-sm" (click)="repairModal.open()">تصحیح</button>
    <button class="btn btn-yellow fs-sm" (click)="open(tab.name)">ایجاد</button>
  </div>


  <div class="col-12 relative" style="min-height: 400px;" [ngSwitch]="tab.name">
    <ngx-spinner name="action" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
    <section class="container-fluid">
      <app-pagination (page)="page=$event" [limit]="20" [total]="total"></app-pagination>
      <div class="row fs-normal sticky  dark-gray-bg f-yellow text-center">
        <div class="col-3 " (click)="setOrder('header')">{{tab.title}}</div>
        <div class="col border-left border-right">مشابه‌ها</div>
        <div class="col-1" (click)="setOrder('user')">کارجو</div>
        <div class="col-1" (click)="setOrder('job')">آگهی</div>
        <div class="col-1">عملیات</div>
      </div>
      <ng-container *ngFor="let metadata of list| filter:{Type:tab.name}:search:page">
        <div class="row border-bottom light-yellow-bg-hover">
          <div class="col-3 overflow-auto" style="max-height: 100px;">
            <div>"{{metadata.Header}}"</div>
          </div>
          <div class="col border-left border-right">
            <div class="py-1">
              <div class="badge-kp px-1 py-1 light-gray-bg ml-1 mb-1" *ngFor="let item of metadata.Variations"
                (click)="openVariate(metadata.Type, item)">{{item}}
              </div>
            </div>
          </div>
          <div class="col-1">{{skills.user[metadata.Header]||'-'}}</div>
          <div class="col-1">{{skills.job[metadata.Header]||'-'}}</div>
          <div class="col-1 d-flex justify-content-between py-1">
            <i class="fa fa-edit fs-lg ml-1 pointer" (click)="open(metadata)"></i>
            <i class="fa fa-trash fs-lg ml-1 pointer" (confirm)="delete(metadata.Id)"></i>
            <ng-container *ngIf="metadata.Type==MetadataType.WrongSkill">
              <i class="fa fa-play-circle fs-lg ml-1 pointer f-red" *ngIf="!metadata.IsProcessed"
                (confirm)="process(metadata)"
                [message]="'با اجرای این دستور مهارت ['+metadata.Header+'] از کل پایگاه داده حذف میگردد. اجرا شود؟'"></i>
              <i class="fa fa-check fs-lg ml-1 pointer" *ngIf="!metadata.IsProcessed"
                [class.f-green]="metadata.IsVerified" [title]="metadata.IsVerified?'تایید شده':'تایید نشده'"
                (click)="verify(metadata)"></i>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </section>
  </div>
</div>

<ngx-smart-modal #metadataModal identifier="metadataModal" [ngSwitch]="selected?.Type" customClass="full-width">
  <div class="w-100 px-3 fs-normal" style="min-height: 600px;">
    <ngx-spinner name="metadata" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
    <div class="d-flex justify-content-between align-items-center px-4">
      <label class="d-flex">
        <span class="no-wrap ml-1">حداقل ارتباط </span>
        <input type="number" inputmode="numeric" [(ngModel)]="minConnections" (change)="load(true)" />
      </label>
      <button class="btn btn-yellow fs-sm" type="button" (click)="save()">ذخیره</button>
    </div>

    <ng-container *ngSwitchCase="MetadataType.Skill">
      <h3 class="text-center">مهارت‌های اصلی</h3>
      [{{keies?.length}}]
      <div class="form-group">
        <div>مهارت اصلی</div>
        <ng-select name="header" [addTag]="true" [items]="selected.Variations" [virtualScroll]="true"
          [(ngModel)]="selected.Header" [selectOnTab]="true" placeholder="انتخاب مهارت اصلی"></ng-select>
      </div>
      <div class="form-group">
        <div>انتخاب مهارت‌های مشابه</div>
        <ng-select name="variations" [multiple]="true" [addTag]="true" [items]="keies" [virtualScroll]="true"
          [(ngModel)]="selected.Variations" [selectOnTab]="true" placeholder="لیست مهارت‌ها" [closeOnSelect]="false">
          <ng-template ng-option-tmp let-item="item">
            <ng-container *ngTemplateOutlet="template;context:{key:item,type:MetadataType.Skill}"></ng-container>
          </ng-template>
        </ng-select>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="MetadataType.WrongSkill">
      <h3 class="text-center">مهارت‌ اشتباه</h3>
      <div class="form-group">
        <div>انتخاب مهارت‌ اشتباه</div>
        <ng-select name="header" [items]="keies" [virtualScroll]="true" [(ngModel)]="selected.Header"
          [selectOnTab]="true" placeholder="لیست مهارت‌ها">
          <ng-template ng-option-tmp let-item="item">
            <ng-container *ngTemplateOutlet="template;context:{key:item,type:MetadataType.WrongSkill}"></ng-container>
          </ng-template>
        </ng-select>
      </div>
      <div class="form-group">
        <div>مهارت‌های درست</div>
        <ng-select name="variations" [multiple]="true" [addTag]="true" [items]="keies" [virtualScroll]="true"
          [(ngModel)]="selected.Variations" [selectOnTab]="true" placeholder="لیست مهارت‌ها" [closeOnSelect]="false">
          <ng-template ng-option-tmp let-item="item">
            <ng-container *ngTemplateOutlet="template;context:{key:item,type:MetadataType.WrongSkill}"></ng-container>
          </ng-template>
        </ng-select>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="-1">
      <h3 class="text-center">مهارت‌ گروهی اشتباه</h3>
      <div class="form-group">
        <div>انتخاب مهارت‌ درست</div>
        <ng-select name="header" [items]="keies" [virtualScroll]="true" [(ngModel)]="selected.Header"
          [selectOnTab]="true" placeholder="لیست مهارت‌ها">
          <ng-template ng-option-tmp let-item="item">
            <ng-container *ngTemplateOutlet="template;context:{key:item,type:-1}"></ng-container>
          </ng-template>
        </ng-select>
      </div>
      <div class="form-group">
        <div>مهارت‌های اشتباه</div>
        <ng-select name="variations" [multiple]="true" [addTag]="true" [items]="keies" [virtualScroll]="true"
          [(ngModel)]="selected.Variations" [selectOnTab]="true" placeholder="لیست مهارت‌ها" [closeOnSelect]="false">
          <ng-template ng-option-tmp let-item="item">
            <ng-container *ngTemplateOutlet="template;context:{key:item,type:-1}"></ng-container>
          </ng-template>
        </ng-select>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="MetadataType.JobTitle">
      <h3 class="text-center">مهارت‌های شغلی</h3>
      <div class="form-group">
        <div>عنوان شغل</div>
        <input name="header" type="text" [(ngModel)]="selected.Header" />
      </div>
      <div class="form-group">
        <div>مهارت‌های اصلی</div>
        <ng-select name="variations" *ngIf="!reordering" [multiple]="true" [addTag]="true" [items]="keies"
          [virtualScroll]="true" [(ngModel)]="selected.Variations" [selectOnTab]="true" (change)="samples()"
          placeholder="لیست مهارت‌ها" [closeOnSelect]="false">
          <ng-template ng-option-tmp let-item="item">
            <ng-container *ngTemplateOutlet="template;context:{key:item,type:MetadataType.JobTitle,order:true}">
            </ng-container>
          </ng-template>
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-icon left" *ngIf="index(item)" (click)="up(item)">«</span>
            <span class="ng-value-label">{{item}}</span>
            <span class="ng-value-icon right" (click)="clear(item)">×</span>
            <span class="ng-value-icon right" *ngIf="index(item)<selected.Variations.length-1"
              (click)="down(item)">»</span>
          </ng-template>
        </ng-select>
      </div>
      <section class="relative" style="min-height: 200px;">
        <ngx-spinner name="samples" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
        <div *ngIf="sample" class="row">
          <div class="col">
            <div>تعداد کاربران: {{sample.userTotal}}</div>
            <hr />
            <div class="row fs-normal sticky  dark-gray-bg f-yellow text-center">
              <div class="col-2">نام</div>
              <div class="col-1">همراه</div>
              <div class="col-1">ایمیل</div>
              <div class="col-7">مهارت‌ها</div>
            </div>
            <div class="row fs-sm border-bottom light-yellow-bg-hover" *ngFor="let user of sample.users">
              <div class="col-2"><a [routerLink]="['/resume',user.Seeker?.Code]" target="_blank">{{user.Name}}</a></div>
              <div class="col-1">{{user.Username}}</div>
              <div class="col-1">{{user.Email}}</div>
              <div class="col-7">{{user.Seeker.Skills|join:' | ':'Title'}}</div>
            </div>
          </div>
          <div class="col">
            <div class="col-3">تعداد آگهی‌ها: {{sample.jobTotal}}</div>
            <hr />
            <div class="row fs-normal sticky  dark-gray-bg f-yellow text-center">
              <div class="col-3">عنوان</div>
              <div class="col-2">منبع</div>
              <div class="col-7">مهارت‌ها</div>
            </div>
            <div class="row fs-sm border-bottom light-yellow-bg-hover" *ngFor="let job of sample.jobs">
              <div class="col-3">{{job.Title}}</div>
              <div class="col-2">{{getSource(job)}}</div>
              <div class="col-7">{{job.RequiredSkills|join:' | '}}</div>
            </div>
          </div>
        </div>
      </section>
    </ng-container>

    <ng-container *ngSwitchCase="MetadataType.JobType">
      <h3 class="text-center">دسته بندی مشاغل</h3>
      <div class="form-group">
        <div>عنوان دسته</div>
        <input name="header" type="text" [(ngModel)]="selected.Header" />
      </div>
      <!-- <div class="form-group">
        <div>عنوانین شغلی</div>
        <ng-select name="variations" *ngIf="!reordering" [multiple]="true" [addTag]="true" [items]="keies"
          [virtualScroll]="true" [(ngModel)]="selected.Variations" [selectOnTab]="true" (change)="samples()"
          placeholder="لیست مهارت‌ها" [closeOnSelect]="false">
          <ng-template ng-option-tmp let-item="item">
            <ng-container *ngTemplateOutlet="template;context:{key:item,type:MetadataType.JobType,order:true}">
            </ng-container>
          </ng-template>
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-icon left" *ngIf="index(item)" (click)="up(item)">«</span>
            <span class="ng-value-label">{{item}}</span>
            <span class="ng-value-icon right" (click)="clear(item)">×</span>
            <span class="ng-value-icon right" *ngIf="index(item)<selected.Variations.length-1"
              (click)="down(item)">»</span>
          </ng-template>
        </ng-select>
      </div> -->
    </ng-container>

  </div>
</ngx-smart-modal>

<ngx-smart-modal #variationModal identifier="variationModal" customClass="full-width">
  <div class="w-100 px-3 fs-normal" style="min-height: 600px;">
    <ngx-spinner name="metadata" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
    <div class="d-flex justify-content-between align-items-center px-4">
      <button class="btn btn-yellow fs-sm" type="button" (click)="variate()">ذخیره</button>
    </div>

    <div class="form-group">
      <div>تبدیل مهارت از {{variateMeta.Header}}</div>
      <ng-select name="variations" [multiple]="true" [addTag]="true" [items]="keies" [virtualScroll]="true"
        [(ngModel)]="variateMeta.Variations" [selectOnTab]="true" placeholder="لیست مهارت‌ها" [closeOnSelect]="false">
        <ng-template ng-option-tmp let-item="item">
          <ng-container *ngTemplateOutlet="template;context:{key:item}"></ng-container>
        </ng-template>
      </ng-select>
    </div>

  </div>
</ngx-smart-modal>

<ngx-smart-modal #repairModal identifier="repairModal" customClass="full-width">
  <div class="w-100 px-3 fs-normal" style="min-height: 600px;">
    <ngx-spinner name="repair" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
    <div class="d-flex justify-content-between align-items-center px-4">
      <button class="btn btn-yellow fs-sm" type="button" (click)="repair()">ذخیره</button>
    </div>

    <div class="form-group">
      <div>کسی که قبلا مهارت های زیر را داشته</div>
      <ng-select name="old_skills" [multiple]="true" [addTag]="true" [items]="keies" [virtualScroll]="true"
        [(ngModel)]="repairMeta.OldSkills" [selectOnTab]="true" placeholder="لیست مهارت‌ها قبلی"
        [closeOnSelect]="false">
        <ng-template ng-option-tmp let-item="item">
          <ng-container *ngTemplateOutlet="template;context:{key:item}"></ng-container>
        </ng-template>
      </ng-select>
    </div>

    <div class="form-group">
      <div>مهارت های زیر افزوده شود</div>
      <ng-select name="new_skills" [multiple]="true" [addTag]="true" [items]="keies" [virtualScroll]="true"
        [(ngModel)]="repairMeta.AddSkills" [selectOnTab]="true" placeholder="لیست مهارت‌ها جدید"
        [closeOnSelect]="false">
        <ng-template ng-option-tmp let-item="item">
          <ng-container *ngTemplateOutlet="template;context:{key:item}"></ng-container>
        </ng-template>
      </ng-select>
    </div>

    <div class="form-group">
      <div>مهارت های زیر حذف شود</div>
      <ng-select name="delete_skills" [multiple]="true" [addTag]="true" [items]="keies" [virtualScroll]="true"
        [(ngModel)]="repairMeta.RemoveSkills" [selectOnTab]="true" placeholder="لیست مهارت‌ها حذفی"
        [closeOnSelect]="false">
        <ng-template ng-option-tmp let-item="item">
          <ng-container *ngTemplateOutlet="template;context:{key:item}"></ng-container>
        </ng-template>
      </ng-select>
    </div>

  </div>
</ngx-smart-modal>

<ng-template #template let-key="key" let-type="type">
  <div class="row">
    <div class="col-1 d-flex flex-wrap">
      <div class="badge" *ngFor="let status of statuses(key)">{{status}}</div>
    </div>
    <div class="col overflow-auto font-weight-bold">[{{key}}]</div>
    <div class="col-2 d-flex align-items-center justify-content-between">
      <div title="کارجو">{{skills.user[key]||'-'}}</div>
      <div title="آگهی">{{skills.job[key]||'-'}}</div>
      <div>
        <i *ngIf="type==MetadataType.WrongSkill || type==MetadataType.JobTitle" title="افزودن مهارت اصلی"
          class="fa fa-check-circle fs-lg f-green ml-1" (click)="add($event,key,MetadataType.Skill)"></i>
        <i *ngIf="type==MetadataType.Skill || type==MetadataType.JobTitle" title="افزودن مهارت اشتباه"
          class="fa fa-times fs-lg f-red ml-1" (click)="add($event,key,MetadataType.WrongSkill)"></i>
      </div>

    </div>
  </div>
</ng-template>